import Popconfirm from './src/popconfirm2.mjs';
export { popconfirmEmits, popconfirmProps } from './src/popconfirm.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElPopconfirm = withInstall(Popconfirm);

export { ElPopconfirm, ElPopconfirm as default };
//# sourceMappingURL=index.mjs.map
